import { Gutter } from "antd/es/grid/row";

// Form validation messages
type ValueType = string | number | undefined;
export const amountFormatter = (value: ValueType) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const amountParser = (value: ValueType) => `${value}`!.replace(/\$\s?|(,*)/g, "");

// Form sizes
export const formGutter: [Gutter, Gutter] = [24, 0];
